// Hook simple para manejar permisos de cámara en navegadores que soportan Permissions API
import { useEffect, useState, useCallback } from 'react';

function useCameraPermission() {
  const [status, setStatus] = useState('unknown'); // 'unknown' | 'granted' | 'denied' | 'prompt' | 'unsupported'
  const [error, setError] = useState(null);

  // Sondeo inicial y suscripción a cambios (si existe Permissions API)
  useEffect(() => {
    let permStatus;

    async function check() {
      try {
        if (navigator?.permissions && navigator.permissions.query) {
          // @ts-ignore: algunos TS no traen 'camera' tipado
          permStatus = await navigator.permissions.query({ name: 'camera' });
          setStatus(permStatus.state); // 'granted' | 'denied' | 'prompt'
          permStatus.onchange = () => setStatus(permStatus.state);
        } else {
          // Safari y otros: no soportan query → status 'prompt' hasta probar
          setStatus('prompt');
        }
      } catch {
        setStatus('unsupported');
      }
    }
    check();

    return () => {
      if (permStatus) permStatus.onchange = null;
    };
  }, []);

  // Acción para solicitar permiso explícitamente
  const request = useCallback(async () => {
    setError(null);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      // Cerrar cámaras al instante para no dejar el stream abierto
      stream.getTracks().forEach(t => t.stop());
      setStatus('granted');
    } catch (err) {
      setStatus('denied');
      setError(err?.message || 'No se pudo acceder a la cámara');
    }
  }, []);

  return { status, request, error };
}

export default useCameraPermission;
